// extracted by mini-css-extract-plugin
module.exports = {"vocalsAndLyrics":"VocalAndLyricsFilter_vocalsAndLyrics__9H_ot"};